import { render, staticRenderFns } from "./LotterySelection.vue?vue&type=template&id=16b56ae5&scoped=true&"
import script from "./LotterySelection.vue?vue&type=script&lang=js&"
export * from "./LotterySelection.vue?vue&type=script&lang=js&"
import style0 from "./LotterySelection.vue?vue&type=style&index=0&id=16b56ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b56ae5",
  null
  
)

export default component.exports